import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";


import ErrorMessage from "../components/ErrorMessage";
import LoadingProgress from "../components/LoadingProgress";
import CustomerCashList from "../components/CustomerCashList";
import CustomerPDAList from "../components/CustomerPDAList";
import CustomerManagerList from "../components/CustomerManagerList";

import { fetchCustomer, fetchCustomers } from "../actions/customers";
import { fetchSLAs } from "../actions/slas";
import AssignedZoneList from "../components/AssignedZoneList";
import AssignedComissionList from "../components/AssignedComissionList";

import "../styles/CustomerDetailsView.css";

const TABS = [
  { key: "general",       label: "General",          icon: "fa-user" },
  { key: "billing",       label: "Facturación",       icon: "fa-file-invoice-dollar" },
  { key: "business",      label: "Negocio",           icon: "fa-briefcase" },
  { key: "integration",   label: "Integración",       icon: "fa-plug" },
  { key: "features",      label: "Funcionalidades",   icon: "fa-toggle-on" },
  { key: "articles",      label: "Artículos & Zonas", icon: "fa-shopping-cart" },
  { key: "users",         label: "Usuarios",          icon: "fa-users" },
];

class CustomerDetailsView extends React.Component {
  constructor(props) {
    super(props);
    this.state = { activeTab: "general" };
  }

  componentDidMount() {
    this.props.fetchCustomer(this.props.match.params.id);
    this.props.fetchCustomers();
    this.props.fetchSLAs();
  }

  getSAPModel(model) {
    switch (model) {
      case "VC":
        return "VENTAS CONTADO (Punto de Venta)";
      case "CV":
        return "COMISION VENTA (Solicitud Factura)";
      default:
        return model || "—";
    }
  }

  renderFeatureBadge(enabled) {
    return enabled
      ? <span className="cust-feature-badge enabled"><i className="fas fa-check-circle mr-1"></i>Activo</span>
      : <span className="cust-feature-badge disabled"><i className="fas fa-times-circle mr-1"></i>Inactivo</span>;
  }

  render() {
    const { role, type, customers, customer, error, loading } = this.props;
    const { activeTab } = this.state;

    if (error) {
      return <ErrorMessage message={error.message} />;
    }

    if (!customer || !customers || loading) {
      return <LoadingProgress />;
    }

    const slaLabel = (() => {
      if (!customer.SLA || !this.props.slas) return "—";
      const sla = this.props.slas.find((s) => s._id === customer.SLA);
      if (!sla) return "—";
      return sla.zone === "ES_PENINSULA" ? "España Península"
        : sla.zone === "ES_ISLANDS" ? "España Islas"
        : sla.zone === "EU_ZONE1" ? "Europa Zona 1"
        : sla.zone === "EU_ZONE2" ? "Europa Zona 2"
        : sla.zone;
    })();

    return (
      <div className="customer-details-view">
        {/* Header */}
        <div className="cust-admin-header">
          <div className="header-content">
            <div className="header-text">
              <h1>
                <i className="fas fa-user mr-3"></i>
                {customer.Fullname}
              </h1>
              <div className="cust-header-meta">
                <span className="cust-meta-badge type">{customer.Type}</span>
                {customer.Category && <span className="cust-meta-badge category">{customer.Category}</span>}
                {customer.Vertical && <span className="cust-meta-badge vertical">{customer.Vertical}</span>}
              </div>
            </div>
            {role === "ADMIN" && type === "MASTER" && (
              <div className="header-actions">
                <Link to={`/customers/${customer._id}/edit`} className="cust-admin-btn primary">
                  <i className="fas fa-edit"></i><span>Editar</span>
                </Link>
                <button className="cust-admin-btn warning is-disabled" disabled>
                  <i className="fas fa-plus"></i><span>Añadir CashControl</span>
                </button>
                <button className="cust-admin-btn secondary is-disabled" disabled>
                  <i className="fas fa-plus"></i><span>Añadir PDAControl</span>
                </button>
                <button className="cust-admin-btn info is-disabled" disabled>
                  <i className="fas fa-plus"></i><span>Añadir Manager</span>
                </button>
              </div>
            )}
          </div>
        </div>

        {/* Tab Nav */}
        <div className="cust-tab-nav">
          {TABS.map(tab => (
            <button
              key={tab.key}
              className={`cust-tab-btn${activeTab === tab.key ? " active" : ""}`}
              onClick={() => this.setState({ activeTab: tab.key })}
            >
              <i className={`fas ${tab.icon} mr-2`}></i>
              {tab.label}
            </button>
          ))}
        </div>

        {/* Tab Panels */}
        <div className="cust-tab-content">

          {/* GENERAL */}
          {activeTab === "general" && (
            <div className="cust-tab-grid">
              <div className="customer-card">
                <div className="card-header-custom">
                  <i className="fas fa-user mr-2"></i>Identificación
                </div>
                <div className="card-body-custom">
                  {[
                    { label: "Nombre completo", icon: "fa-user", value: customer.Fullname },
                    { label: "Persona de contacto", icon: "fa-user-tie", value: customer.Contact_person },
                    { label: "E-Mail", icon: "fa-envelope", value: customer.Email },
                    { label: "Teléfono", icon: "fa-phone", value: customer.Phone },
                    { label: "Idioma", icon: "fa-language", value: customer.Language },
                    { label: "Grupo", icon: "fa-users", value: customer.Group },
                    { label: "Email de Reportes", icon: "fa-envelope-open-text", value: customer.IncidencesEmail },
                    { label: "ID Externo", icon: "fa-external-link-alt", value: customer.ExternalId },
                  ].map(({ label, icon, value }) => (
                    <div className="info-row" key={label}>
                      <div className="info-label"><i className={`fas ${icon} mr-2`}></i>{label}</div>
                      <div className="info-value">{value || "—"}</div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="customer-card">
                <div className="card-header-custom">
                  <i className="fas fa-sliders-h mr-2"></i>Configuración
                </div>
                <div className="card-body-custom">
                  {[
                    { label: "Tipo", icon: "fa-tag", value: customer.Type },
                    { label: "Categoría", icon: "fa-layer-group", value: customer.Category },
                    { label: "SLA", icon: "fa-shield-alt", value: slaLabel },
                    { label: "Última edición", icon: "fa-user-edit", value: customer.Executor },
                    { label: "Bearer Token", icon: "fa-key", value: customer._id },
                  ].map(({ label, icon, value }) => (
                    <div className="info-row" key={label}>
                      <div className="info-label"><i className={`fas ${icon} mr-2`}></i>{label}</div>
                      <div className="info-value">{value || "—"}</div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="customer-card">
                <div className="card-header-custom">
                  <i className="fas fa-map-marker-alt mr-2"></i>Ubicación
                </div>
                <div className="card-body-custom">
                  {[
                    { label: "Dirección", icon: "fa-map-marker-alt", value: customer.Address },
                    { label: "Código Postal", icon: "fa-mail-bulk", value: customer.PostalCode },
                    { label: "Ciudad", icon: "fa-city", value: customer.City },
                    { label: "Provincia", icon: "fa-map", value: customer.Province },
                    { label: "País", icon: "fa-globe", value: customer.Country },
                  ].map(({ label, icon, value }) => (
                    <div className="info-row" key={label}>
                      <div className="info-label"><i className={`fas ${icon} mr-2`}></i>{label}</div>
                      <div className="info-value">{value || "—"}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* BILLING */}
          {activeTab === "billing" && (
            <div className="cust-tab-grid">
              <div className="customer-card">
                <div className="card-header-custom">
                  <i className="fas fa-file-invoice-dollar mr-2"></i>Facturación
                </div>
                <div className="card-body-custom">
                  {[
                    { label: "NIF/CIF", icon: "fa-id-card", value: customer.Invoice_taxid },
                    { label: "IVA aplicable (%)", icon: "fa-percent", value: customer.Invoice_tax },
                    { label: "Razón social", icon: "fa-building", value: customer.Social_name },
                    { label: "Dirección de facturación", icon: "fa-map-marker-alt", value: customer.Invoice_address },
                  ].map(({ label, icon, value }) => (
                    <div className="info-row" key={label}>
                      <div className="info-label"><i className={`fas ${icon} mr-2`}></i>{label}</div>
                      <div className="info-value">{value || "—"}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* BUSINESS */}
          {activeTab === "business" && (
            <div className="cust-tab-grid">
              <div className="customer-card">
                <div className="card-header-custom">
                  <i className="fas fa-briefcase mr-2"></i>Modelo de Negocio
                </div>
                <div className="card-body-custom">
                  {[
                    { label: "Modelo", icon: "fa-cogs", value: customer.BusinessModel },
                    { label: "Vertical", icon: "fa-arrows-alt-v", value: customer.Vertical },
                    { label: "Alquiler Anual", icon: "fa-euro-sign", value: customer.SpaceRentalAlquiler ? `${customer.SpaceRentalAlquiler} €` : null },
                  ].map(({ label, icon, value }) => (
                    <div className="info-row" key={label}>
                      <div className="info-label"><i className={`fas ${icon} mr-2`}></i>{label}</div>
                      <div className="info-value">{value || "—"}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* INTEGRATION */}
          {activeTab === "integration" && (
            <div className="cust-tab-grid">
              <div className="customer-card">
                <div className="card-header-custom">
                  <i className="fas fa-credit-card mr-2"></i>TPV Virtual (Redsys)
                </div>
                <div className="card-body-custom">
                  {[
                    { label: "Código de comercio", icon: "fa-code", value: customer.Redsys?.MERCHANTCODE },
                    { label: "Clave de cifrado", icon: "fa-lock", value: customer.Redsys?.SECRETKEY },
                    { label: "Moneda", icon: "fa-coins", value: customer.Redsys?.CURRENCY },
                    { label: "Terminal", icon: "fa-desktop", value: customer.Redsys?.TERMINAL },
                    { label: "URL Tienda", icon: "fa-link", value: customer.Redsys?.MERCHANTURL },
                  ].map(({ label, icon, value }) => (
                    <div className="info-row" key={label}>
                      <div className="info-label"><i className={`fas ${icon} mr-2`}></i>{label}</div>
                      <div className="info-value">{value || "—"}</div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="customer-card">
                <div className="card-header-custom">
                  <i className="fas fa-industry mr-2"></i>SAP
                </div>
                <div className="card-body-custom">
                  {[
                    { label: "Modelo", icon: "fa-cogs", value: this.getSAPModel(customer.SAP?.Model) },
                    { label: "CompanyID", icon: "fa-building", value: customer.SAP?.CompanyID },
                    { label: "CountryCode", icon: "fa-globe", value: customer.SAP?.CountryCode },
                    { label: "ClientID", icon: "fa-user", value: customer.SAP?.ClientID },
                    { label: "SiteID", icon: "fa-map-marker-alt", value: customer.SAP?.SiteID },
                    { label: "TaxCountryCode", icon: "fa-flag", value: customer.SAP?.TaxCountryCode },
                    { label: "TaxationCharacteristicsCode", icon: "fa-calculator", value: customer.SAP?.TaxationCharacteristicsCode },
                    { label: "InventoryManagedLocationID", icon: "fa-warehouse", value: customer.SAP?.InventoryManagedLocationID },
                    { label: "LogisticsAreaID", icon: "fa-truck", value: customer.SAP?.LogisticsAreaID },
                    { label: "TaxRegionCode", icon: "fa-map", value: customer.SAP?.TaxRegionCode },
                  ].map(({ label, icon, value }) => (
                    <div className="info-row" key={label}>
                      <div className="info-label"><i className={`fas ${icon} mr-2`}></i>{label}</div>
                      <div className="info-value">{value || "—"}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* FEATURES */}
          {activeTab === "features" && (
            <div className="cust-tab-grid">
              <div className="customer-card">
                <div className="card-header-custom">
                  <i className="fas fa-toggle-on mr-2"></i>Comunicaciones
                </div>
                <div className="card-body-custom">
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px" }}>
                    {[
                      { label: "WhatsApp", icon: "fa-whatsapp", fab: true, value: customer.WhatsAppCommunications },
                      { label: "SMS", icon: "fa-sms", value: customer.SMSCommunications },
                    ].map(({ label, icon, fab, value }) => (
                      <div key={label} style={{
                        display: "flex", alignItems: "center", gap: "8px",
                        padding: "10px 14px", borderRadius: "8px",
                        background: value ? "rgba(40,167,69,0.08)" : "rgba(0,0,0,0.04)",
                        border: value ? "1px solid rgba(40,167,69,0.3)" : "1px solid rgba(0,0,0,0.1)",
                      }}>
                        <i className={`${fab ? 'fab' : 'fas'} ${icon}`} style={{ color: value ? "#28a745" : "#adb5bd", fontSize: "15px", width: "18px", textAlign: "center" }} />
                        <span style={{ fontSize: "13px", fontWeight: 500, color: "#495057", flex: 1 }}>{label}</span>
                        {value
                          ? <span style={{ fontSize: "11px", fontWeight: 600, color: "#28a745", textTransform: "uppercase", letterSpacing: "0.5px" }}>Activo</span>
                          : <span style={{ fontSize: "11px", fontWeight: 600, color: "#adb5bd", textTransform: "uppercase", letterSpacing: "0.5px" }}>Inactivo</span>
                        }
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="customer-card">
                <div className="card-header-custom">
                  <i className="fas fa-puzzle-piece mr-2"></i>Módulos Activos
                </div>
                <div className="card-body-custom">
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px" }}>
                    {[
                      { label: "Códigos Canjeables", icon: "fa-qrcode", value: customer.FeatureRedeemCodes },
                      { label: "Códigos de Pulsera (RFID)", icon: "fa-id-badge", value: customer.FeatureWristbandCodes },
                      { label: "Calendarios de Precios", icon: "fa-calendar-alt", value: customer.FeatureCalendars },
                      { label: "Plantillas de Email", icon: "fa-envelope-open-text", value: customer.FeatureEmailTemplates },
                      { label: "Partners", icon: "fa-handshake", value: customer.FeaturePartners },
                      { label: "Códigos de Descuento", icon: "fa-tags", value: customer.FeatureDiscountCodes },
                    ].map(({ label, icon, value }) => (
                      <div key={label} style={{
                        display: "flex", alignItems: "center", gap: "8px",
                        padding: "10px 14px", borderRadius: "8px",
                        background: value ? "rgba(40,167,69,0.08)" : "rgba(0,0,0,0.04)",
                        border: value ? "1px solid rgba(40,167,69,0.3)" : "1px solid rgba(0,0,0,0.1)",
                      }}>
                        <i className={`fas ${icon}`} style={{ color: value ? "#28a745" : "#adb5bd", fontSize: "15px", width: "18px", textAlign: "center" }} />
                        <span style={{ fontSize: "13px", fontWeight: 500, color: "#495057", flex: 1 }}>{label}</span>
                        {value
                          ? <span style={{ fontSize: "11px", fontWeight: 600, color: "#28a745", textTransform: "uppercase", letterSpacing: "0.5px" }}>Activo</span>
                          : <span style={{ fontSize: "11px", fontWeight: 600, color: "#adb5bd", textTransform: "uppercase", letterSpacing: "0.5px" }}>Inactivo</span>
                        }
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* ARTICLES & ZONES */}
          {activeTab === "articles" && (
            <div className="cust-tab-grid">
              <div className="customer-card">
                <div className="card-header-custom">
                  <i className="fas fa-shopping-cart mr-2"></i>Artículos
                </div>
                <div className="card-body-custom">
                  <AssignedComissionList items={customer.Items} />
                </div>
              </div>
              <div className="customer-card">
                <div className="card-header-custom">
                  <i className="fas fa-door-closed mr-2"></i>Zonas
                </div>
                <div className="card-body-custom">
                  <AssignedZoneList Zones={customer.Zones} />
                </div>
              </div>
            </div>
          )}

          {/* USERS */}
          {activeTab === "users" && (
            <div className="cust-tab-grid">
              <div className="customer-card">
                <div className="card-header-custom">
                  <i className="fas fa-cash-register mr-2"></i>Usuarios Cash Control
                </div>
                <div className="card-body-custom">
                  <CustomerCashList customers={customers} customer={customer} />
                </div>
              </div>
              <div className="customer-card">
                <div className="card-header-custom">
                  <i className="fas fa-tablet-alt mr-2"></i>Usuarios PDA Control
                </div>
                <div className="card-body-custom">
                  <CustomerPDAList customers={customers} customer={customer} />
                </div>
              </div>
              <div className="customer-card">
                <div className="card-header-custom">
                  <i className="fas fa-user-tie mr-2"></i>Usuarios Manager
                </div>
                <div className="card-body-custom">
                  <CustomerManagerList customers={customers} customer={customer} />
                </div>
              </div>
            </div>
          )}

        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  customers: state.customers.customers,
  customer: state.customers.customer,
  loading: state.customers.loading,
  error: state.customers.error,
  role: state.auth.role,
  type: state.auth.type,
  slas: state.slas.slas,
});

const mapDispatchToProps = (dispatch) => ({
  fetchCustomer: bindActionCreators(fetchCustomer, dispatch),
  fetchCustomers: bindActionCreators(fetchCustomers, dispatch),
  fetchSLAs: bindActionCreators(fetchSLAs, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CustomerDetailsView);
